import { PropsWithChildren, useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { CurrentLanguageContext } from "../contexts/currentLanguage";
import i18n from "../i18n";
import axios from "axios";
import { getAuthToken } from "../api/AxiosServices";

export function CurrentLanguageManager({ children }: PropsWithChildren) {

    const [currentLanguage, setCurrentLanguage] = useState<string>('fr');
    const auth = useAuth()
    useEffect(() => {
        if (auth.isAuthenticated && auth?.user?.profile) {
            setCurrentLanguage(auth?.user?.profile?.locale || 'fr')
        }
    }, [auth])


    async function changeLanguage(lng: any, givenName: string | null = null, familyName: string | null = null, email: string | null = null) {
        if (givenName && familyName && email) {
            await updateUserAccountLocale(lng, givenName, familyName, email)
        }
        await i18n.changeLanguage(lng);
        setCurrentLanguage(i18n.language);
        i18n.reloadResources();
    };



    async function updateUserAccountLocale(selectedCountry: string, firstName: string, lastName: string, email: string) {
        const data = {
            email: email,
            firstName: firstName,
            lastName: lastName,
            "attributes": {
                locale: selectedCountry,
            }
        }
        return axios.post(`${process.env.REACT_APP_OIDC_AUTHORITY}/account`, data, {
            headers: {
                "Content-type": "application/json",
                "Authorization": `Bearer ${getAuthToken()}`
            }
        })
    }

    useEffect(() => {
        if (auth.isAuthenticated) {
            changeLanguage(currentLanguage, auth?.user?.profile.given_name || "", auth?.user?.profile?.family_name || "", auth?.user?.profile?.email || "")
        } else {
            changeLanguage(currentLanguage)
        }
    }, [currentLanguage, auth])


    return <CurrentLanguageContext.Provider value={{ currentLanguage, setCurrentLanguage }}>
        {children}
    </CurrentLanguageContext.Provider>

}